import { apiGet, apiPatch } from '../client';
import type { BankTransactionListResponseApi } from '../models/bankTransaction';

export async function getAllBankTransactions(): Promise<BankTransactionListResponseApi> {
  return apiGet<BankTransactionListResponseApi>('transactions/bank');
}

export async function updateBankTransactionCategory(id: number, category: string): Promise<void> {
  return apiPatch<void>(`transactions/bank/${id}/category`, { category });
}
